import React from "react";
import { connect } from "react-redux";
import { GeoJSONLayer, Layer, Feature } from "react-mapbox-gl";
import { developmentSelectors } from "../../../../../state/development";
import buildingGeoJson from "../../../../../utils/buildingGeoJson";
import mapboxPresentationProperties from "../../../../utils/mapboxPresentationProperties";
import turf from "../../../../../utils/turf";

const PIN_PROJECT_ZOOM = 14;

const mapStateToProps = (state) => {
  return {
    buildingModel: developmentSelectors.getBuildingModel(state),
    parcelGeoJSON: developmentSelectors.getParcel(state),
  };
}

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

class Building extends React.PureComponent<Props, {}> {
  /**
   * Render building.
   */
  renderBuilding = () => {
    let buildingData = buildingGeoJson.geoJsonFor(this.props.buildingModel);
    if (!buildingData) return null;

    return (
      <GeoJSONLayer
        data={buildingData as any}
        fillExtrusionPaint={mapboxPresentationProperties.buildingFillExtrusionPaint as any}
        layerOptions={{ minzoom: PIN_PROJECT_ZOOM } as any}
      />
    );
  }

  render() {
    return (
      <>
        <GeoJSONLayer
          data={this.props.parcelGeoJSON}
          linePaint={mapboxPresentationProperties.parcelFootprintLinePaint}
          fillPaint={mapboxPresentationProperties.parcelFootprintFillPaint}
          layerOptions={{ minzoom: PIN_PROJECT_ZOOM } as any}
        />
        {this.renderBuilding()}

        <Layer
          type="symbol"
          layout={mapboxPresentationProperties.mapPinLayout}
          maxZoom={PIN_PROJECT_ZOOM}
        >
          <Feature coordinates={turf.getCoord(turf.centerOfMass(this.props.parcelGeoJSON))} />
        </Layer>
      </>
   );
  }
}

export default connect(
  mapStateToProps
)(Building);
